import React, { useState, useEffect } from 'react';
import DateInput from './DateInput';

const modalStyles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1000,
    display: 'flex', alignItems: 'center', justifyContent: 'center'
  },
  modal: {
    background: 'white', padding: '20px', borderRadius: '8px',
    width: '90%', maxWidth: '560px'
  },
  inputRow: { display: 'flex', gap: '8px', marginBottom: '12px', alignItems: 'center', flexWrap: 'wrap' },
  dateRow: { width: '100%', marginBottom: '8px' },
  addRow: { display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' },
  dateInput: { flex: 1, minWidth: '120px', padding: '8px' },
  typeSelect: { flex: 1, minWidth: '110px', padding: '8px' },
  hourInput: { flex: 1, minWidth: '70px', padding: '8px' },
  reasonInput: { flex: 2, minWidth: '120px', padding: '8px' },
  addButton: { padding: '8px 12px', cursor: 'pointer', background: '#007bff', color: 'white', border: 'none', borderRadius: '4px' },
  list: { listStyle: 'none', padding: 0, maxHeight: '280px', overflowY: 'auto', border: '1px solid #eee', padding: '10px' },
  listItem: { display: 'flex', flexDirection: 'column', gap: '6px', padding: '10px', borderBottom: '1px solid #f0f0f0' },
  listItemRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  removeButton: { background: '#dc3545', color: 'white', border: 'none', cursor: 'pointer', padding: '2px 8px', borderRadius: '4px', fontSize: '0.85rem' },
  buttons: { display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' },
  saveButton: { padding: '8px 12px', cursor: 'pointer', background: '#28a745', color: 'white', border: 'none', borderRadius: '4px' },
  cancelButton: { padding: '8px 12px', cursor: 'pointer', background: '#6c757d', color: 'white', border: 'none', borderRadius: '4px' }
};

function latenessTypeLabel(type) {
  if (type === 'early') return '조퇴';
  if (type === 'industrial_care') return '산재요양';
  return '지각';
}

const LatenessModal = ({
  isOpen,
  onClose,
  onSave,
  onDetailsChange,
  currentDetails = [],
  workRecordId,
  currentVersion,
  isMonthClosed,
  selectedYear,
  selectedMonth,
}) => {
  const [details, setDetails] = useState(currentDetails);
  const [newDate, setNewDate] = useState('');
  const [newType, setNewType] = useState('late');
  const [newHours, setNewHours] = useState('');
  const [newReason, setNewReason] = useState('');

  const formatDate = (d) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const monthStart = (selectedYear && selectedMonth)
    ? new Date(selectedYear, selectedMonth - 1, 1)
    : null;
  const monthEnd = (selectedYear && selectedMonth)
    ? new Date(selectedYear, selectedMonth, 0)
    : null;

  const minDate = monthStart ? formatDate(monthStart) : undefined;
  const maxDate = monthEnd ? formatDate(monthEnd) : undefined;

  useEffect(() => {
    setDetails(currentDetails);
  }, [currentDetails, isOpen]);

  if (!isOpen) return null;

  const totalHours = details.reduce((sum, item) => sum + (parseFloat(item.hours) || 0), 0);

  const handleAddItem = () => {
    if (!newDate) {
      alert('날짜를 선택해주세요.');
      return;
    }
    const hours = parseFloat(newHours);
    if (isNaN(hours) || hours <= 0) {
      alert('시간을 0보다 큰 값으로 입력해주세요.');
      return;
    }
    if (minDate && maxDate && (newDate < minDate || newDate > maxDate)) {
      alert(`${selectedYear}년 ${selectedMonth}월 안의 날짜만 입력할 수 있습니다.`);
      return;
    }
    const newItem = {
      date: newDate,
      type: newType,
      hours,
      reason: newReason.trim()
    };
    const newDetails = [...details, newItem].sort((a, b) => a.date.localeCompare(b.date));
    setDetails(newDetails);
    setNewDate('');
    setNewType('late');
    setNewHours('');
    setNewReason('');
    if (onDetailsChange) onDetailsChange(newDetails);
  };

  const handleRemoveItem = (index) => {
    const newDetails = details.filter((_, i) => i !== index);
    setDetails(newDetails);
    if (onDetailsChange) onDetailsChange(newDetails);
  };

  const handleSave = () => {
    const latenessDetails = details.map(item => ({
      date: item.date,
      type: item.type,
      hours: parseFloat(item.hours) || 0,
      reason: item.reason || ''
    }));
    onSave(workRecordId, {
      latenessDetails,
      version: currentVersion
    });
    onClose();
  };

  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
          <h3>지각/조퇴/산재요양 관리</h3>
          <span style={{ fontSize: '0.8rem', color: '#666' }}>Version: {currentVersion}</span>
        </div>

        <div style={{ marginBottom: '12px' }}>
          <div style={{ marginBottom: '8px' }}>
            <DateInput value={newDate} onChange={setNewDate} style={{ width: '100%', minWidth: '380px' }} inputStyle={{ padding: '8px' }} disabled={isMonthClosed} />
          </div>
          <div style={modalStyles.inputRow}>
            <select
              style={modalStyles.typeSelect}
              value={newType}
              onChange={(e) => setNewType(e.target.value)}
              disabled={isMonthClosed}
            >
              <option value="late">지각</option>
              <option value="early">조퇴</option>
              <option value="industrial_care">산재요양</option>
            </select>
            <input
              type="number"
              placeholder="시간"
              style={modalStyles.hourInput}
              value={newHours}
              onChange={(e) => setNewHours(e.target.value)}
              step="0.5"
              min="0.5"
              disabled={isMonthClosed}
            />
            <input
              type="text"
              placeholder="사유 (선택)"
              style={modalStyles.reasonInput}
              value={newReason}
              onChange={(e) => setNewReason(e.target.value)}
              disabled={isMonthClosed}
            />
            <button
              type="button"
              style={modalStyles.addButton}
              onClick={handleAddItem}
              disabled={isMonthClosed}
            >
              추가
            </button>
          </div>
        </div>

        <p style={{ fontWeight: 'bold', marginTop: '10px', marginBottom: '8px' }}>총 {totalHours.toFixed(1)} 시간</p>
        <ul style={modalStyles.list}>
          {details.length > 0 ? details.map((item, index) => (
            <li key={index} style={modalStyles.listItem}>
              <div style={modalStyles.listItemRow}>
                <span style={{ fontWeight: 'bold' }}>
                  {item.date} · {latenessTypeLabel(item.type)} ({item.hours}h)
                  {item.reason ? ` - ${item.reason}` : ''}
                </span>
                <button
                  style={modalStyles.removeButton}
                  onClick={() => handleRemoveItem(index)}
                  disabled={isMonthClosed}
                >
                  삭제
                </button>
              </div>
            </li>
          )) : (
            <li style={{ color: '#666', padding: '10px' }}>지각/조퇴/산재요양 내역이 없습니다.</li>
          )}
        </ul>

        <div style={modalStyles.buttons}>
          <button type="button" style={modalStyles.cancelButton} onClick={onClose}>취소</button>
          <button
            type="button"
            style={modalStyles.saveButton}
            onClick={handleSave}
            disabled={isMonthClosed}
          >
            저장하기
          </button>
        </div>
      </div>
    </div>
  );
};

export default LatenessModal;
